import {initialUsersLogTable} from "./helper";
import updateObject from "../../util/updateObject";
import * as actionTypes from "./actionTypes";

const initialState = {
    usersLogTable: initialUsersLogTable
};


const setUsersLogTable = (state, action) => updateObject(state, {
    usersLogTable: updateObject(
        state.usersLogTable,
        {[action.key]: action.value},
    ),
});

const userManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_USERS_LOG:
            return setUsersLogTable(state, action);
        default:
            return state;
    }
};

export default userManagementReducer;